import * as React from 'react'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'

interface InputProps extends React.ComponentProps<'input'> {}

function Input({className, ...props}: InputProps) {
  return (
    <input
      data-slot='input'
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground text-sm font-normal',
        'dark:bg-input/30 border-border h-10 w-full min-w-0 rounded-md border bg-transparent',
        'px-3 py-1 text-base transition-[color,box-shadow] outline-none',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        'group-data-[has-left-icon=true]:pl-11',
        'group-data-[has-right-icon=true]:pr-11',
        className,
      )}
      {...props}
    />
  )
}

interface InputGroupProps extends React.HTMLAttributes<HTMLDivElement> {}

function InputGroup({className, children, ...props}: InputGroupProps) {
  const childrenArray = React.Children.toArray(children)

  const hasLeftIcon = childrenArray.some((child) => {
    return React.isValidElement(child) && typeof child.type === 'function' && child.type.name === InputIconLeft.name
  })

  const hasRightIcon = childrenArray.some((child) => React.isValidElement(child) && typeof child.type === 'function' && child.type.name === InputIconRight.name)

  return (
    <div
      data-slot='input-group'
      data-has-left-icon={hasLeftIcon}
      data-has-right-icon={hasRightIcon}
      className={cn('group relative flex w-full items-center', className)}
      {...props}>
      {children}
    </div>
  )
}

interface InputIconProps extends React.HTMLAttributes<HTMLSpanElement> {}

function InputIconLeft({className, ...props}: InputIconProps) {
  return (
    <span
      data-slot='input-icon-left'
      className={cn('text-muted-foreground pointer-events-none absolute inset-y-0 left-3 z-10 flex items-center [&>svg]:size-4', className)}
      {...props}
    />
  )
}

function InputIconRight({className, ...props}: InputIconProps) {
  return (
    <span
      data-slot='input-icon-right'
      className={cn('text-muted-foreground pointer-events-auto absolute inset-y-0 right-1 z-10 flex items-center [&>svg]:size-4', className)}
      {...props}
    />
  )
}

export {Input, InputGroup, InputIconLeft, InputIconRight}
